import { BaseModel } from "../base-model";

export interface IDemandConfig {
  DemandContractDurationMonths?: number;
}
export class DemandConfig extends BaseModel<IDemandConfig>
  implements IDemandConfig {
    DemandContractDurationMonths?: number;
  /**
   *
   */
  constructor(option?: IDemandConfig) {
    super(option);
  }
}
